﻿import { action, makeObservable, observable } from "mobx";
import dicomParser from "dicom-parser";
import { DicomTags } from "../app/viewer/network/contracts/dicom/DicomDataSet";
import { DicomTag } from "../app/viewer/network/contracts/dicom/DicomTag";

export class DicomFileReader {
    @observable
    file: File;

    @observable
    reading = false;

    @observable
    dataSet: dicomParser.DataSet | null = null;

    constructor(file: File) {
        makeObservable(this);
        this.file = file;
    }

    public async readFile(): Promise<void> {
        this.setReading(true);
        return new Promise((resolve, reject) => {
            this.file.arrayBuffer().then(buff => {
                const array = new Uint8Array(buff);

                const headerArray = array.subarray(128, 132);
                const headerInfo = String.fromCodePoint(...headerArray);

                let dataSet: dicomParser.DataSet | null = null;

                if (headerInfo === "DICM") {
                    try {
                        dataSet = dicomParser.parseDicom(array);
                    } catch (e) {
                        console.error(e);
                        dataSet = null;
                    }
                }

                this.setDataSet(dataSet);
                this.setReading(false);

                return resolve();
            });
        });
    }

    @action
    private setReading(value: boolean) {
        this.reading = value;
    }

    @action
    private setDataSet(dataSet: dicomParser.DataSet | null) {
        this.dataSet = dataSet;
    }

    public getDicomTag(key: DicomTags): DicomTag {
        const tag = key.substring(0, 4) + "," + key.substring(4, 8);
        const name = Object.keys(DicomTags)[Object.values(DicomTags).indexOf(key)];

        let value = "";
        if (this.dataSet) {
            value = this.dataSet.string("x" + key.toLowerCase()) ?? "";
        }

        return new DicomTag(name, tag, value, key);
    }
}
